import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export default function VisitsChartCard({ rows, loading }) {
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-white/10 dark:bg-slate-900">
      <div className="border-b border-slate-200 p-4 dark:border-white/10 sm:p-5 lg:p-6">
        <h2 className="text-xl font-bold text-slate-900 dark:text-white">
          Évolution des visites
        </h2>

        <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
          Courbe du nombre de visites comptabilisées par jour.
        </p>
      </div>

      <div className="p-3 sm:p-5 lg:p-6">
        {loading ? (
          <div className="h-[380px] animate-pulse rounded-[24px] bg-slate-200 dark:bg-slate-800" />
        ) : rows.length === 0 ? (
          <div className="rounded-[24px] border border-dashed border-slate-300 p-10 text-center text-slate-500 dark:border-white/10 dark:text-slate-400">
            Aucune visite enregistrée pour le moment.
          </div>
        ) : (
          <div className="h-[420px] rounded-[24px] border border-slate-200 bg-white p-3 dark:border-white/10 dark:bg-slate-950">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={rows} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                <defs>
                  <linearGradient id="visitsGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="currentColor" stopOpacity={0.35} />
                    <stop offset="95%" stopColor="currentColor" stopOpacity={0.02} />
                  </linearGradient>
                </defs>

                <CartesianGrid strokeDasharray="3 3" opacity={0.25} />

                <XAxis
                  dataKey="date_label"
                  tick={{ fontSize: 12 }}
                  tickMargin={10}
                />

                <YAxis
                  allowDecimals={false}
                  tick={{ fontSize: 12 }}
                  tickMargin={10}
                />

                <Tooltip
                  contentStyle={{
                    borderRadius: "16px",
                    border: "1px solid rgba(148,163,184,.35)",
                    boxShadow: "0 20px 40px rgba(15,23,42,.15)",
                  }}
                  labelFormatter={(label) => `Date : ${label}`}
                  formatter={(value) => [
                    `${Number(value).toLocaleString("fr-FR")} visite(s)`,
                    "Visites",
                  ]}
                />

                <Area
                  type="monotone"
                  dataKey="compteur"
                  name="Visites"
                  stroke="currentColor"
                  strokeWidth={3}
                  fill="url(#visitsGradient)"
                  className="text-primary"
                  activeDot={{ r: 7 }}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}